


















import { Component, Prop, Vue } from 'vue-property-decorator';
import FixedMenu from './FixedMenu';
import { BooleanProp } from '@pjn/vue-core/component';

const FM: any = FixedMenu;

/** 
 * Componente emergente (tipo menu) pero con "punta" como globo de historieta 
 * */
@Component({ components: { FixedMenu: FM } })
export default class Balloon extends Vue {
  
  /** Padding inferior del menu con respecto a su activador */
  @Prop({ default: 6 }) paddingBottom: number;

  /** Padding izquierdo del menu con respecto a su activador */
  @Prop({ default: 0 }) paddingLeft: number;

  /** Padding derecho del menu con respecto a su activador */
  @Prop({ default: 0 }) paddingRight: number;

  /** Clase que se aplicara al menu */
  @Prop({ default: '' }) contentClasses: string;

  /** Fijar en la pantalla cuando se hace scroll */
  @BooleanProp(false) fixed: boolean;

  private get componentName() {
    return this.fixed ? 'FixedMenu' : 'v-menu';
  }

  private get classes() {
    return ` balloon ${this.contentClasses}`;
  }
}
